import React from 'react';
import { Panel } from 'govuk-react-jsx/govuk/components/panel';
import { useSelector } from 'react-redux';
import { Button } from 'govuk-react-jsx/govuk/components/button';
import { Link } from 'react-router-dom';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import { getPMCData } from '../../features/pmc/pmcJourneySlice';
import useTitle from '../../hooks/useTitle';
import useGaEndEvent from '../../hooks/useGaEndEvent';
import { useSetReduxState } from '../../hooks/useResetReduxState';

const PMCClientRegistered = () => {
  const [setResetReduxState] = useSetReduxState();
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const pmcClientData = useSelector(getPMCData);

  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;

  useTitle(
    'pmcClientReg.PmcClientRegistered.s10',
    'Client successfully registered - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );

  useGaEndEvent('PmcClientRegistration', 'pmc_cl_reg_end');

  const handleButtonClick = () => {
    setResetReduxState('pmcJourney', 'registrationJourney');
    window.location.assign('/dashboardHub/dashboard-pmc');
  };

  const pageModel = (
    <div>
      <Panel
        titleChildren={copyProvider.getCopy(
          'pmcClientReg.PmcClientRegistered.s1',
          'Client successfully registered'
        )}
      />
      <p className="govuk-body">
        {copyProvider.getCopy(
          'pmcClientReg.PmcClientRegistered.s2',
          'Your client '
        )}
        {pmcClientData?.businessName}
        {copyProvider.getCopy(
          'pmcClientReg.PmcClientRegistered.s3',
          ' has been added to your account.'
        )}
      </p>
      <h2 className="govuk-heading-m">
        {copyProvider.getCopy(
          'pmcClientReg.PmcClientRegistered.s4',
          'What happens next'
        )}
      </h2>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'pmcClientReg.PmcClientRegistered.s5',
          'You can apply for the grant on the behalf of your client.'
        )}
      </p>
      <p className="govuk-body">
        <Link
          className="govuk-link"
          to={{}}
          onClick={() =>
            window.open(
              'https://www.gov.uk/government/publications/ev-chargepoint-grant-for-landlords-customer-guidance',
              '_blank'
            )
          }
        >
          {copyProvider.getCopy(
            'pmcClientReg.PmcClientRegistered.s6',
            'Read more about the OZEV Electric Vehicle Chargepoint Grant for landlords'
          )}
        </Link>
      </p>
      <p className="govuk-body">
        <Link
          to={{}}
          onClick={() =>
            window.open('https://www.smartsurvey.co.uk/s/EV-grants/', '_blank')
          }
        >
          {copyProvider.getCopy(
            'pmcClientReg.PmcClientRegistered.s7',
            'What did you think of this service? '
          )}
        </Link>
        {copyProvider.getCopy(
          'pmcClientReg.PmcClientRegistered.s8',
          '(takes 30 seconds)'
        )}
      </p>
      <Button
        className="govuk-button govuk-!-margin-top-3"
        onClick={handleButtonClick}
      >
        {copyProvider.getCopy(
          'pmcClientReg.PmcClientRegistered.s9',
          'Manage your application'
        )}
      </Button>
    </div>
  );
  return pageModel;
};

export default PMCClientRegistered;
